import { useEffect } from "react";
import SomethingWentWrongCard from "components/card/something-went-wrong/SomethingWentWrongCard";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { clearPersistedState } from "store/persistUtils";
import { markPolicyEventFiredInSession } from "utils/abandonmentTracking";

interface SomethingWentWrongPageProps {
    retryUrl?: string;
}

const SomethingWentWrongPage = ({ retryUrl = "/invitation" }: SomethingWentWrongPageProps) => {
    useEffect(() => {
        pushGTMEvent(GA_EVENT_CONFIGS.POLICY_SYSTEM_ERROR);
        markPolicyEventFiredInSession();
        clearPersistedState();
    }, []);

    return (
        <>
            <title>Something Went Wrong | AAA Life</title>
            <ApplicationContainer data-testid="something-went-wrong-page">
                <SomethingWentWrongCard retryUrl={retryUrl} />
            </ApplicationContainer>
        </>
    );
};

export { SomethingWentWrongPage };
export default SomethingWentWrongPage;
